$(document).ready(function(){ 
          $('.tab-li').click(function(){  
            $(".tab").removeClass('tab-active');
            $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
            $(".tab-li").removeClass('active-a');
            $(this).addClass('active-a');
          });
          $('.tab-li-2').click(function(){  
            $(".tab-2").removeClass('tab-active');
            $(".tab-2[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
            $(".tab-li-2").removeClass('active-a');
            $(this).addClass('active-a');
          });
      });